import * as actionTypes from './LoginActionTypes';
import * as serviceEndPoint from '../../../../SharedModule/Service/service';
import axios from 'axios';

export const LoginUserActions = (value) => {
  return dispatch => {
    return axios.post(`${serviceEndPoint.LOGIN_USER}`, value)
      .then(response => {
        dispatch(LoginUser(response.data));
      })
      .catch(error => {
        dispatch(LoginUser({ systemFailure: true }));
      });
  };
};
export const LoginUser = (loginUser) => {
  return ({
    type: actionTypes.LOGIN_USER,
    loginUser: loginUser
  });
};

export const LoginAdminActions = (value) => {
  return dispatch => {
    return axios.post(`${serviceEndPoint.LOGIN_ADMIN}`, value)
      .then(response => {
        dispatch(LoginAdmin(response.data));
      })
      .catch(error => {
        dispatch(LoginAdmin({ systemFailure: true }));
      });
  };
};
export const LoginAdmin = (loginAdmin) => {
  return ({
    type: actionTypes.LOGIN_ADMIN,
    loginAdmin: loginAdmin
  });
};

export const resetLoginData = (key) => {
  return {
    type: actionTypes.RESET_LOGIN_DATA,
    key: key
  };
};